import { QC_OUTCOME_TYPES, type QCOutcomeType } from '@/types';
import React from 'react';

import QCBadge from './index';

function isQCOutcome(value: string): value is QCOutcomeType {
  return (QC_OUTCOME_TYPES as readonly string[]).includes(value);
}

// Shared AG Grid cellRenderer for QC-outcome columns (Instrument Runs, Study Detail samples).
// AG Grid types cell values as `any`, so narrow the raw wire string before rendering — an
// unexpected value falls back to plain text instead of an uncolored dot and a blank label.
export function qcCellRenderer({ value }: { value?: string | null }) {
  if (!value) return null;
  if (isQCOutcome(value)) return <QCBadge qc={value} />;
  return value;
}
